import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   allOCTWedgePlay,
   deleteOCTWedgePlay,
   fetchOCTWedgePlay,
   studentOCTWedgePlay,
   allStudents,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddItem from './component/addform';
import EditItem from './component/editform';

class captoreport extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:false,
            adddiv:false,
            editdiv:false,
            seldate:'', 
            student:'',
            sepmore:1,
            formValues: [{ distance:"", right : "", left : "", short : "", long : "", area:"", contact:"", putt : "", missedgreen : "0", disright:"", disleft:"", disshort:"", dislong:""}],
         };  
         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

   UNSAFE_componentWillMount() {
	   //this.props.allOCTWedgePlay();
      this.props.allStudents();
	}

   onAddSession() {
		this.setState({ 
         viewdiv:false,
         listdiv:false,
         editdiv:false,
         adddiv:true,
      });
   } 
      
   onBackSection() {
		this.setState({ 
         adddiv:false,
         editdiv:false,
         viewdiv:true,
         listdiv:true,
       });
	} 
   
   selstudent = (evt) =>{
      var stdid=evt.value;
      this.setState({ student:stdid });
      var start='';
      var end='';
      this.props.studentOCTWedgePlay(stdid, start, end).then((data) => {   
         
         this.setState({ 
             listdiv:true,               
             adddiv:false,
             editdiv:false,
         });

     });
   }


   editAssessment(assmval){
        
      var id=assmval.gcy_userID;
      var date=assmval.gcy_date;
        
        this.props.fetchOCTWedgePlay(id, date).then((data) => {   
            
         var resdata=data.data;
         var troptobj=[]; 
         {resdata.map((teamval) => (   
            troptobj.push({
               distance: teamval.gcy_dth,
               right: teamval.gcy_right,
               left: teamval.gcy_left,
               short: teamval.gcy_short,
               long: teamval.gcy_long,
               area: teamval.gcy_area,
               contact: teamval.gcy_contact,
               putt: teamval.gcy_putt,
               missedgreen:teamval.gcy_dhg,
               disright:teamval.gcy_right==0 ? 0 : 1, 
               disleft:teamval.gcy_left==0 ? 0 : 1, 
               disshort:teamval.gcy_short==0 ? 0 : 1, 
               dislong:teamval.gcy_long==0 ? 0 : 1,
            })
         ))} 
         this.setState({ 
            seldate:resdata[0].gcy_date, 
            student:resdata[0].gcy_userID,
            formValues:troptobj,
            sepmore:resdata.length
         });                  

         this.setState({ 
             viewdiv:false, 
             listdiv:false,              
             adddiv:false,
             editdiv:true,
         });

        });
    }

    deleteForm(assmval){
      this.id = assmval.gcy_userID;
      this.date = assmval.gcy_date;
      this.confirmationDialog.current.openDialog();
    }

   deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteOCTWedgePlay(this.id, this.date);
            this.data = ""
        }
   }

   

    render() {
      const { match, studentlists, octwedgelist, loading } = this.props;
      const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
      });
      const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            responsive:'standard',
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
      };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "action", label: "EDIT" },
            { name: "action1", label: "DELETE" },
          
        ];
        const tabledata=octwedgelist.map((assmntval,idx) => {     
               const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;     
               const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                action: ebtn,
                action1:dbtn,
                
                }
        }); 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>On Course Wedge Play Test | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.oncwedgeplay" />} match={match} />
             {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}> 
                        <Label for="Select">Student *</Label> 
                        <FormGroup>   
                           <Label for="Select">Student *</Label>                                           
                           <Selectsearch id="student" name="student" placeholder="Select..." options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                        </FormGroup>
                  </div>
               }       
               {this.state.listdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Test</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                  <EditItem onClick={this.onBackSection} data={this.state}/>              
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'wedge play test'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, octwedge }) => {
   const { studentlists } = mostlyused;
	const { octwedgelist, loading } = octwedge;
	return { studentlists, octwedgelist, loading };
}

export default connect(mapStateToProps, {
   allOCTWedgePlay,
   deleteOCTWedgePlay,
   fetchOCTWedgePlay,
   studentOCTWedgePlay,
   allStudents,
})(captoreport); 